import moment from "moment";
import { Tooltip, Modal, ModalHeader, ModalBody } from 'reactstrap';
import React, { useState } from "react";

const formatter = new Intl.NumberFormat('en-US');

const formatCurrency = (cost) => {
    return '$' + formatter.format(Math.round(cost));
}

const modalBody = (procedure) => {
    
    return <div className='calculated-cost-modal'>
        <div className='row'>
            <div className='col-10'>
                <p className='text-uppercase'>Estimated Cost for Procedure</p>
                <p className='font-italic'>(Negotiated Cost)</p>
            </div>
            <div className='col-2 text-right cost-med'>{formatCurrency(procedure.avgTotCost)}</div>
        </div>
        <div className='row text-uppercase light-grey-background'>Details based on your plan</div>
        <div className='row text-uppercase'>
            <div className='col'>Remaining Deductible</div>
            <div className='col text-right cost-med'>{formatCurrency(procedure.deductibleRemaining)}</div>
        </div>
        <div className='row text-uppercase'>
            <div className='col'>Coinsurance Percentage</div>
            <div className='col text-right cost-med'>{Math.round(procedure.coinsurance)}%</div>
        </div>
        <div className='row text-uppercase'>
            <div className='col-10'>Remaining Out-of-pocket Max</div>
            <div className='col-2 text-right cost-med'>{formatCurrency(procedure.oopRemaining)}</div>
        </div>
        <div className='row text-uppercase'>
            <div className='col'>Estimated Amount Plan Pays</div>
            <div className='col text-right cost-med'>{formatCurrency(procedure.planPays)}</div>
        </div>
        <div className='row text-uppercase blue-background'>
            <div className='col-10'>Your Estimated Out of Pocket Cost</div>
            <div className='col-2 text-right cost-med'>{formatCurrency(procedure.oopEstimate)}</div>
        </div>
        {/*<div className='row'> 
            Save money by using preferred providers. Having this procedure at an non-preferred provider could cost you as much as $5,909.
        </div>//TO-DO*/}
        <div className='row font-italic light-grey-background'>
            * The calculation of your out-of-pocket expense is for the current plan year and is a good-faith estimate based on the information that you have provided. However, your actual out-of-pocket expenses may vary depending upon many factors, including the intensity of the condition, the complexity of treating the condition, the medical provider, or inaccuracies in the information used in calculation.
            Estimates are quoted for procedures done with Preferred Network providers. Costs increase for procedures with Out-of-Network providers.

        </div>
    </div>;
}

export const CostSummary = (props) => {
    const [showOOPTooltip, setShowOOPTooltip] = useState(false);
    const [showCBBTooltip, setShowCBBTooltip] = useState(false);
    const [showCalculatedModal, setShowCalculatedModal] = useState(false);

    let { procedureCost, memberDisplayName } = props;
    
    const toggle = () => setShowCalculatedModal(!showCalculatedModal);

    const toggleOOPTooltip = () => {
        setShowOOPTooltip(!showOOPTooltip);
    }

    const toggleCBBToolTip = () => {
        setShowCBBTooltip(!showCBBTooltip);
    }

    return <div className='cost-summary'>
        <div className='h2 text-center'> {procedureCost.procedureName}</div>
        <div className='header-label text-center'>Estimate for <span className='orange-text'>{memberDisplayName}</span></div>
        <div className=' h4 bold-text'>Out-of-Pocket Costs <span className="icon-question" id="OOP-Tooltip" /></div>
        <Tooltip placement="top" isOpen={showOOPTooltip} autohide={false} target="OOP-Tooltip" toggle={toggleOOPTooltip}>
            Out-of-Pocket Costs include deductibles, coinsurance and copayments.
            </Tooltip>
            <hr />
            <div className='row text-center'>
                <div className='col'>
                    <div className='card'>
                        <div className='bold-test sub-header-label'>Amount You Pay</div>
                        <div className='orange-text cost-large'>{formatCurrency(procedureCost.oopEstimate)}*</div>
                    <div>If the procedure is performed by {moment().endOf('year').format("MM/D/YYYY")}</div>
                    <div><button className='no-style-button' onClick={() => { setShowCalculatedModal(true) }}>How is this calculated?</button></div>
                    </div>
                </div>
                <div className='col'>
                    <div className='card'>
                        <div className='bold-test sub-header-label'>Amount Plan Pays</div>
                    <div className='cost-large'>{formatCurrency(procedureCost.planPays)}*</div>
                        <p></p>
                    <div><button className='no-style-button' onClick={() => { setShowCalculatedModal(true) }}>How is this calculated?</button></div>
                    </div>
                </div>

            </div>
        <div className='h4 bold-text'>Costs Before Benefits <span className="icon-question" id="CBB-Tooltip" /></div>
        <Tooltip placement="top" isOpen={showCBBTooltip} autohide={false} target="CBB-Tooltip" toggle={toggleCBBToolTip}>
            The average total costs shown are only applicable to in-network providers and facilities. Out-of-network costs may be higher.
         </Tooltip>
        {/*What costs are included in this estimate?*/}
        <hr />
        <div className='row text-center'>
            <div className='col'>
                <div className='card'>
                    <div className='sub-header-label'>Average Total Cost</div>
                    <div className='cost-med'>{formatCurrency(procedureCost.avgTotCost)}</div>
                    <hr />
                    <div className='range'>Range: {procedureCost.minTotCost} - {procedureCost.maxTotCost}</div>
                </div>
            </div>
            <div className='col'>
                <div className='card'>
                    <div className='sub-header-label'>Average Facility Cost</div>
                    <div className='cost-med'>{formatCurrency(procedureCost.avgFacCost)}</div>
                    <hr />
                    <div className='range'>Range: {procedureCost.minFacCost} - {procedureCost.maxFacCost}</div>
                </div>
            </div>
            <div className='col'>
                <div className='card'>
                    <div className='sub-header-label'>Average Physician Cost</div>
                    <div className='cost-med'>{formatCurrency(procedureCost.avgDocCost)}</div>
                    <hr />
                    <div className='range'>Range: {procedureCost.minDocCost} - {procedureCost.maxDocCost}</div>
                </div>
            </div>
        </div>
        <Modal isOpen={showCalculatedModal} toggle={toggle} className='calculated-cost-modal'>
            <ModalHeader toggle={toggle}>{procedureCost.procedureName}</ModalHeader>
            <ModalBody>{modalBody(procedureCost)}</ModalBody>
        </Modal>
    </div>;
}